export default __webpack_public_path__ + "static/media/silver_star.8a48af97.svg";